import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import Header from '../AssetHealthApp/Header';
import EmptyWidget from '../Custom/EmptyWidget';
import CardBox from '../Custom/CardBox';
import SpinnerIcon from '../Custom/SpinnerIcon';
import DivLocAsset from '../AssetHealthApp/DivLocAsset';
import AppWidget from '../Custom/AppWidget';
import Breadcrumb from '../Custom/Breadcrumb';
import SLDViewerContainer from './SLDViewerContainer';

class NewSLDViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      obj: {
        sldName: '',
        id: 0,
        substationName: '', // change SLD title
        divId: 0,
        breadCrumbName: '',
      },
    };
  }

  setSelectedSLD(sldName, val, substationName, divId, breadCrumbName) {
    this.setState({
      obj: {
        sldName,
        id: val,
        substationName, // change SLD title
        divId,
        breadCrumbName: breadCrumbName,
      },
    });
  }

  onchange(obj) {
    if (obj.type === 'Location' && obj.location !== '') {
      if (obj.locObj?.SLDName?.toLowerCase() !== this.state.selectedSLD) {
        this.setSelectedSLD(
          obj.locObj.SLDName.toLowerCase(),
          obj.location,
          obj.locObj.assetPointName,
          Number(obj.division),
          obj.locObj.BreadCrumbName
        ); // change SLD title
      }
    } else {
      this.setState({
        obj: {
          sldName: '',
          substationName: '', // change SLD title
          id: 0,
          divId: 0,
          breadCrumbName: '',
        },
      });
    }
  }

  render() {
    const { obj } = this.state;
    return (
      <div>
        <Header
          BrandText={'SLD'}
          legendObj={[]}
          islegendObj={false}
          iconsObj={[]}
        ></Header>
        <DivLocAsset
          isFeeder={false}
          isReportLevel={false}
          isLocation={true}
          dvSize={4}
          isSLDViewer={true}
          appId={2}
          onChange={this.onchange.bind(this)}
        />
        <Row>
          <Breadcrumb
            breadCrumbName={obj.breadCrumbName}
            style={{ padding: '5px', marginLeft: '5px' }}
          />
          <AppWidget
            id={'sldWidget'}
            class={'col-lg-12'}
            infoText={'sld'}
            expandText={'SLD'}
            tabs
            isNormalWidget
            hideExpand
          >
            <CardBox height={'calc(100vh - 190px)'} margin={'-10px'}>
              {obj.id !== 0 ? (
                // <NewSLD assetpointId={obj.id} divId={obj.divId} />
                <SLDViewerContainer SubstationId={obj.id} />
              ) : (
                <EmptyWidget emptyText={'Please select Location to view SLD'} />
              )}
            </CardBox>
          </AppWidget>
        </Row>
        <div>
          <div className="internal-indicator">
            <div className="spinner">
              <SpinnerIcon />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewSLDViewer;
